module.exports = __webpack_public_path__ + "img/10.c8f3b8a2.png";